import React, { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Optional, Shimmer } from "sprint-common-web";

import { ContentReferenceType } from "../../../../../../common/types/ContentReferenceType";
import { RecordType } from "../../../../../../common/types/RecordType";
import { ContentAssociationFormState } from "../../../../../common/content/types/ContentAssociationFormState";
import { VersionInfo } from "../../../common/context/CloudFileDashboardContext";
import { useCloudFileDashboard } from "../../../common/context/useCloudFileDashboard";
import { CloudFileAssociationFormState } from "../context/CloudFileAssociationContext";
import { useCloudFileAssociationSection } from "../context/useCloudFileAssociationSection";
import { CloudFileAssociationLanguageTabs } from "./CloudFileAssociationLanguageTabs";
import { CloudFileAssociationVideoTabs } from "./CloudFileAssociationVideoTabs";

export const CloudFileAssociationTabs = (): JSX.Element => {
    const { cloudFileItem } = useCloudFileAssociationSection();

    const { setSelectedVersionInfo } = useCloudFileDashboard();

    const form = useFormContext<CloudFileAssociationFormState>();

    const versionIds = useWatch({
        control: form.control,
        name: "versionIds"
    });

    useEffect(() => {
        const values = form.getValues();
        const versionInfo = mapToVersionInfo(values);

        if (!versionInfo) return;

        setSelectedVersionInfo(versionInfo);
    }, [JSON.stringify(versionIds)]); //TODO: refactor while bumping react-hook-form version

    if (!cloudFileItem) return <Shimmer />;

    return (
        <>
            {cloudFileItem.recordType === RecordType.Video ? (
                <CloudFileAssociationVideoTabs />
            ) : (
                <CloudFileAssociationLanguageTabs />
            )}
        </>
    );
};

const mapToVersionInfo = <T extends ContentAssociationFormState>(content: T): Optional<VersionInfo> => {
    if (!content.contentId) {
        return;
    }

    switch (content.contentType) {
        case ContentReferenceType.Movie:
        case ContentReferenceType.Ancillary:
            return {
                versionIds: content.versionIds ?? [],
                contentType: content.contentType,
                contentId: content.contentId
            };

        case ContentReferenceType.TvSeries:
            if (!content.episodeId) return;

            return {
                versionIds: content.versionIds ?? [],
                contentType: content.contentType,
                contentId: content.episodeId
            };

        default:
            return;
    }
};
